<template>
    <div class="status">
        <span v-if="status === 'accept'" class="accept">通过</span>
        <span v-else-if="status === 'normal'" class="normal">运行完成</span>
        <span v-else-if="status === 'syntax error'" class="syntax-error">语法错误</span>
        <span v-else-if="status === 'wrong answer'" class="wrong-answer">答案错误</span>
        <span v-else-if="status === 'runtime error'" class="runtime-error">运行错误</span>
    </div>
</template>

<script>
export default {
    props: [ 'status' ],
}
</script>

<style>
.accept {
    color: #52c41a;
}
.normal {
    color: #1890ff;
}
.syntax-error, .wrong-answer, .runtime-error {
    color: #f5222d;
}
</style>